<div class="page">
  <div class="topline">
    <div>
      <h2>Sensitive Data Access</h2>
      <p>Review the recorded business reasons for sensitive data access.</p>
    </div>
    <button mat-stroked-button color="primary" type="button" [disabled]="exporting" (click)="exportEvents()">
      <mat-icon>download</mat-icon>
      {{ exporting ? 'Exporting…' : 'Export CSV' }}
    </button>
  </div>

  <mat-form-field appearance="outline" class="search">
    <mat-label>Search all fields</mat-label>
    <input
      matInput
      [(ngModel)]="searchValue"
      (ngModelChange)="queueSearch($event)"
      placeholder="Purpose, actor, reference, resource, outcome…"
      autocomplete="off"
    />
    <button
      *ngIf="searchValue"
      matSuffix
      mat-icon-button
      type="button"
      aria-label="Clear search"
      (click)="clearSearch()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <div class="scroll-container" (scroll)="onScroll($event)">
    <table
      mat-table
      matSort
      [matSortActive]="sortBy"
      [matSortDirection]="sortDirection"
      [matSortDisableClear]="true"
      (matSortChange)="changeSort($event)"
      [dataSource]="events"
      class="table"
    >
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Accessed</th>
        <td mat-cell *matCellDef="let event">
          <div class="stacked-value">
            <span>{{ event.createdAt | date:'mediumDate' }}</span>
            <small>{{ event.createdAt | date:'mediumTime' }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actorId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Actor</th>
        <td mat-cell *matCellDef="let event">
          <div class="stacked-value">
            <span>{{ getActorName(event) }}</span>
            <small>{{ getActorDetail(event) }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="businessPurposeCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Business purpose</th>
        <td mat-cell *matCellDef="let event">{{ formatContextValue(event.businessPurposeCode) }}</td>
      </ng-container>

      <ng-container matColumnDef="referenceId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Reference</th>
        <td mat-cell *matCellDef="let event">
          <div class="stacked-value">
            <span>{{ formatContextValue(event.referenceId) }}</span>
            <small *ngIf="event.referenceType">{{ formatValue(event.referenceType) }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
        <td mat-cell *matCellDef="let event">{{ formatValue(event.action) }}</td>
      </ng-container>

      <ng-container matColumnDef="resourceId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Resource</th>
        <td mat-cell *matCellDef="let event">
          <div class="stacked-value">
            <span>{{ getResourceName(event) }}</span>
            <small>{{ getResourceDetail(event) }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="eventType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Outcome</th>
        <td mat-cell *matCellDef="let event">
          <div class="stacked-value">
            <span>{{ formatValue(event.eventType) }}</span>
            <small *ngIf="event.outcomeCode">{{ formatValue(event.outcomeCode) }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="rowCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Rows</th>
        <td mat-cell *matCellDef="let event">{{ formatValue(event.rowCount) }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="state" *ngIf="loading">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Loading access history…</span>
    </div>
    <div class="state error" *ngIf="loadError && !loading">
      <span>Unable to load access history.</span>
      <button mat-button color="primary" type="button" (click)="retry()">Retry</button>
    </div>
    <div class="state" *ngIf="!loading && !loadError && events.length === 0">
      No sensitive data access records found.
    </div>
    <div class="state end" *ngIf="!loading && !loadError && endOfList && events.length > 0">
      End of access history
    </div>
  </div>
</div>
